/* eslint-disable linebreak-style */
import Vue from 'vue';
import moment from 'moment';

Vue.prototype.moment = moment;

moment.locale((window.navigator.language) && window.navigator.language.split('-')[0]);
